import { SubMenuDefault } from './SubMenuDefault'

function SubMenu({ Component = SubMenuDefault, ...restProps }) {
  return <Component {...restProps} />
}

export default SubMenu
